import React from 'react';

const DeleteSplit = props => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.92252 14.925C3.92252 15.3745 4.1011 15.8057 4.41897 16.1235C4.73684 16.4414 5.16797 16.62 5.61752 16.62H12.3675C12.8171 16.62 13.2482 16.4414 13.5661 16.1235C13.8839 15.8057 14.0625 15.3745 14.0625 14.925V4.76999H3.92252V14.925ZM8.42252 14.925V6.45749H9.75002V14.925H8.42252ZM12.39 14.925H11.2875V6.45749H12.3825L12.39 14.925ZM5.64002 6.45749H6.84002V14.925H5.61752L5.64002 6.45749Z"
      fill="var(--DANGER)"
    />
    <path
      d="M12 2.25L11.115 1.38H6.88501L6.03751 2.25H3.92251C3.70216 2.2518 3.491 2.33861 3.3331 2.49232C3.17519 2.64603 3.08274 2.85478 3.07501 3.075C3.07697 3.29917 3.16689 3.5136 3.3254 3.67211C3.48392 3.83063 3.69835 3.92055 3.92251 3.9225H14.0775C14.3017 3.92055 14.5161 3.83063 14.6746 3.67211C14.8331 3.5136 14.9231 3.29917 14.925 3.075C14.9173 2.85478 14.8248 2.64603 14.6669 2.49232C14.509 2.33861 14.2979 2.2518 14.0775 2.25H12Z"
      fill="var(--DANGER)"
    />
  </svg>
);

export default DeleteSplit;
